import './style.scss'

const Footer = () => {
  return (
    <footer>
      
      Footer

    </footer>
  )
}

export default Footer